"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ExpandableBottomCard = _ref => {
  let {
    open,
    icon,
    title,
    onClose,
    children
  } = _ref;
  if (!open) return null;
  const handleClose = e => {
    e.stopPropagation();
    e.currentTarget === e.target && onClose();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
    onClick: handleClose,
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      zIndex: 1300,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.35)',
      marginTop: '0 !important'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        width: '100%',
        maxWidth: '440px',
        position: 'relative',
        backgroundColor: '#fff',
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        boxShadow: '0px -10px 30px rgba(0,0,0,0.15)',
        margin: 0
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
          px: 3,
          py: 2
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
            sx: {
              mr: 1,
              width: '64px',
              border: '1px solid lightgray',
              borderRadius: '12px',
              padding: '4px 8px'
            },
            children: icon
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            fontSize: "1rem",
            fontWeight: 600,
            children: title
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
          size: "small",
          onClick: onClose,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {})
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        children: children
      })]
    })
  });
};
var _default = exports.default = ExpandableBottomCard;